module.exports = __webpack_public_path__ + "img/jubaochenggong.6dc2834c.png";